import script from "./LocalLineItem.vue?vue&type=script&setup=true&lang=js"
export * from "./LocalLineItem.vue?vue&type=script&setup=true&lang=js"

import "./LocalLineItem.vue?vue&type=style&index=0&id=7836eef0&lang=scss&scoped=true"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7836eef0"]])

export default __exports__